import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../services/apiClient";
import { useTheme } from '../config/ThemeContext';

function MatchReport() {
  const { matchId } = useParams();
  const [reportHtml, setReportHtml] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const colors = useTheme();

  useEffect(() => {
    const fetchReport = async () => {
      try {
        setLoading(true);
        setError(null);
        // Uses apiClient to send the Bearer Token
        const response = await apiClient.get(`/api/matches/${matchId}/report`, {
          responseType: 'text'
        });
        setReportHtml(response.data);
      } catch (err) {
        console.error('Failed to load P2 Match Report:', err);
        setError('Failed to load Match Report. Access denied or not logged in.');
      } finally {
        setLoading(false);
      }
    };

    if (matchId) fetchReport();
  }, [matchId]);

  const handleDownloadPDF = async () => {
    try {
      // Secure Blob Download with Bearer Token
      const response = await apiClient.get(`/api/matches/${matchId}/report/download`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `MatchReport_Match_${matchId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed:', err);
      alert('Failed to download PDF. Check console for details.');
    }
  };

  if (loading) return <div className="p-8 text-center">Loading P2 Match Report...</div>;
  if (error) return <div className="p-8 text-red-600">{error}</div>;

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6 print:hidden">
        <h1 className="text-2xl font-bold">P2 Match Report (Match ID: {matchId})</h1>
        <button onClick={handleDownloadPDF} className={`px-4 py-2 rounded-md ${colors.buttons.primary}`}>
          Download PDF
        </button>
      </div>
      <div className="bg-white rounded-lg shadow-sm border p-6 overflow-auto">
        <div dangerouslySetInnerHTML={{ __html: reportHtml }} />
      </div>
    </div>
  );
}

export default MatchReport;